export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["编辑"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐藏"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["余额"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["加密资产数据"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代码"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["负责人"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资产"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["财务"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["访问"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["详情"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["联系"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["财务特征"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["精度"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发行"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最大发行量"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["单位成本"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["担保"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发行地址"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名称"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资产分发者"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["访问特征"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ATM购买"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ATM销售"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易所资产交易"])},
  "25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["P2P资产交易"])},
  "26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["详细信息"])},
  "27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["类别"])},
  "28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["目标/使命"])},
  "29": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["联系方式"])},
  "30": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除"])},
  "31": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除资产"])},
  "32": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重命名资产"])},
  "33": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐藏资产"])},
  "34": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["区块链类型"])},
  "35": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["法定性质"])},
  "36": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是"])},
  "37": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["否"])},
  "38": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发行更多"])},
  "39": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销毁代币"])}
}